// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");

var allTimeZones = Belt_List.fromArray([
      {
        value: "Pacific/Midway",
        label: "(GMT-11:00) Midway Island, Samoa"
      },
      {
        value: "America/Adak",
        label: "(GMT-10:00) Hawaii-Aleutian"
      },
      {
        value: "Pacific/Honolulu",
        label: "(GMT-10:00) Hawaii"
      },
      {
        value: "America/Anchorage",
        label: "(GMT-09:00) Alaska"
      },
      {
        value: "America/Los_Angeles",
        label: "(GMT-08:00) Pacific Time (US & Canada)"
      },
      {
        value: "America/Denver",
        label: "(GMT-07:00) Mountain Time (US & Canada)"
      },
      {
        value: "America/Chicago",
        label: "(GMT-06:00) Central Time (US & Canada)"
      },
      {
        value: "America/New_York",
        label: "(GMT-05:00) Eastern Time (US & Canada)"
      },
      {
        value: "America/Caracas",
        label: "(GMT-04:30) Caracas"
      },
      {
        value: "America/Halifax",
        label: "(GMT-04:00) Atlantic Time (Canada)"
      },
      {
        value: "America/Argentina/Buenos_Aires",
        label: "(GMT-03:00) Buenos Aires, Georgetown"
      },
      {
        value: "Atlantic/Azores",
        label: "(GMT-01:00) Azores"
      },
      {
        value: "Europe/London",
        label: "(GMT+00:00) London, Lisbon, Casablanca"
      },
      {
        value: "Europe/Berlin",
        label: "(GMT+01:00) Berlin, Brussels, Madrid, Paris"
      },
      {
        value: "Europe/Athens",
        label: "(GMT+02:00) Athens, Bucharest, Istanbul"
      },
      {
        value: "Europe/Moscow",
        label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
      },
      {
        value: "Asia/Tehran",
        label: "(GMT+03:30) Tehran"
      },
      {
        value: "Asia/Dubai",
        label: "(GMT+04:00) Abu Dhabi, Muscat"
      },
      {
        value: "Asia/Kabul",
        label: "(GMT+04:30) Kabul"
      },
      {
        value: "Asia/Karachi",
        label: "(GMT+05:00) Islamabad, Karachi"
      },
      {
        value: "Asia/Kolkata",
        label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
      },
      {
        value: "Asia/Kathmandu",
        label: "(GMT+05:45) Kathmandu"
      },
      {
        value: "Asia/Dhaka",
        label: "(GMT+06:00) Astana, Dhaka"
      },
      {
        value: "Asia/Bangkok",
        label: "(GMT+07:00) Bangkok, Hanoi, Jakarta"
      },
      {
        value: "Asia/Hong_Kong",
        label: "(GMT+08:00) Beijing, Hong Kong, Singapore, Taipei"
      },
      {
        value: "Asia/Tokyo",
        label: "(GMT+09:00) Osaka, Sapporo, Tokyo"
      },
      {
        value: "Australia/Adelaide",
        label: "(GMT+09:30) Adelaide"
      },
      {
        value: "Australia/Sydney",
        label: "(GMT+10:00) Sydney, Melbourne, Brisbane"
      },
      {
        value: "Pacific/Guam",
        label: "(GMT+10:00) Guam, Port Moresby"
      },
      {
        value: "Asia/Magadan",
        label: "(GMT+11:00) Magadan, Solomon Islands, New Caledonia"
      },
      {
        value: "Pacific/Auckland",
        label: "(GMT+12:00) Auckland, Wellington"
      },
      {
        value: "Pacific/Fiji",
        label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is."
      },
      {
        value: "Pacific/Tongatapu",
        label: "(GMT+13:00) Nuku'alofa"
      }
    ]);

function value(t) {
  return t.value;
}

function label(t) {
  return t.label;
}

exports.allTimeZones = allTimeZones;
exports.value = value;
exports.label = label;
/* allTimeZones Not a pure module */
